import SIFormatter from "common/siFormatter";
import Constants from 'common/constants'
import Utils from 'common/utils'
import suncalc from 'suncalc'

export default class WeatherData {
    constructor(weatherObj, generalData) {
        /*
        "time": "",
        "currTemp": "",
        "maxTemp": "",
        "minTemp": "",
        "icon": "",
        "iconPrettyPrint": "",
        "sunriseTime": "",
        "sunsetTime: """,
        "humidity": "",
        "windSpeed": "",
        "cloudCover": "",
        "precipitation": ""
        "apparentTemp": "",
        "dewPoint": "",
        "visibility":"",
        "windDirection": "",
        "pressure": "",
        "wind":"".
        "ozone":"",
        "uv":""
        */

        if (weatherObj === null) {
            return
        }

        // Formatting the code to units using general-data
        var SIUnit = generalData["si"];
        if (typeof (SIUnit) === "undefined" || SIUnit === null) {
            SIUnit = Constants.SI_UNIT_DEFAULT;
        }
        var timezone = generalData["timezone"];

        // These are integral to currently & hourly
        this.time = weatherObj["time"];
        this.timeFormatted = Utils.formatIntoTimeStrForTimezone(this.time, timezone, 'YYYY-MM-DD HH:mm Z a')
        this.timeWeek = Utils.formatIntoTimeStrForTimezone(this.time, timezone, 'ddd')
        this.timeHour = Utils.formatIntoTimeStrForTimezone(this.time, timezone, 'h a')

        this.icon = weatherObj["icon"]
        var iconPrettyPrint = Utils.formatDisplayString(this.icon, true, true, true)
        if (Utils.isNull(iconPrettyPrint)) {
            iconPrettyPrint = "";
        }
        this.iconPrettyPrint = iconPrettyPrint;
        this.currTemp = SIFormatter.convertTempForSI(SIUnit, weatherObj["temperature"])
        this.precipIntensity = Utils.convertDecimalToPercentageString(weatherObj["precipIntensity"])
        this.precipProbability = Utils.convertDecimalToPercentageString(weatherObj["precipProbability"])
        this.windSpeed = SIFormatter.convertSpeedForSI(SIUnit, weatherObj["windSpeed"]);
        this.cloudCover = Utils.convertDecimalToPercentageString(weatherObj["cloudCover"]);

        // These are usually found in daily data
        // Calculate this from the lat-long, since the api gives fixed responses
        var location = generalData["location"]
        if (false === Utils.isNull(location)) {
            var lat = location["lat_num"]
            var lon = location["lon_num"]
            var times = suncalc.getTimes(new Date(), lat, lon)
            var sunriseTimeMillis = times.sunrise.getTime();
            var sunsetTimeMillis = times.sunset.getTime();
            this.sunriseTime = Utils.formatMillisIntoTimeStrForTimezone(sunriseTimeMillis, timezone, 'hh:mm a').replace(/^0/, "");
            this.sunsetTime = Utils.formatMillisIntoTimeStrForTimezone(sunsetTimeMillis, timezone, 'hh:mm a').replace(/^0/, "");
        } else {
            this.sunriseTime = Utils.formatIntoTimeStrForTimezone(weatherObj["sunriseTime"], timezone, 'hh:mm a');
            this.sunsetTime = Utils.formatIntoTimeStrForTimezone(weatherObj["sunsetTime"], timezone, 'hh:mm a');
        }

        this.maxTemp = SIFormatter.convertTempForSI(SIUnit, weatherObj["temperatureMax"]);
        this.minTemp = SIFormatter.convertTempForSI(SIUnit, weatherObj["temperatureMin"]);
        this.humidity = Utils.convertDecimalToPercentageString(weatherObj["humidity"]);

        // Units 
        this.distanceUnit = SIFormatter.getDistanceUnitForSI(SIUnit)
        this.temperatureUnit = SIFormatter.getTempUnitForSI(SIUnit)

        // Additional data-points 
        this.apparentTemp = SIFormatter.convertTempForSI(SIUnit, weatherObj["apparentTemperature"])
        this.dewPoint = SIFormatter.convertTempForSI(SIUnit, weatherObj["dewPoint"])
        this.visibility = SIFormatter.convertDistanceForSI(SIUnit, weatherObj["visibility"])
        this.windDirection = this.getWindDirection(weatherObj["windDirection"])
        this.currentBG = null

        let pressure = weatherObj["pressure"]
        this.ozone=weatherObj["ozone"]
        this.uvIndex=weatherObj["uvIndex"]
        this.moonPhase=weatherObj["moonPhase"];
        if (Utils.isNull(pressure)) {
            pressure = ""
        } else {
            pressure = Utils.formatFloatStrToFixed(`${pressure}`, 2)
        }
        this.pressure = pressure
    }

    getWindDirection(dirnDeg) {
        if (Utils.isNull(dirnDeg) || typeof dirnDeg !== "number") {
            return ""
        }

        /*
        The dirnDeg is - "0 to 360 degrees, from south, clockwise angle"
        Since I have time and am bored, the explicit meaning of the above statement is -

                    N
                    | 180 deg
                    |
        90 deg      |         270 deg
        W --------- | --------- E
                    |
                    |
                    | 0 deg
                    S

        So I am going to assume the following degree ranges - 
        0 - 45 -> south
        45 - 135 -> west
        135 - 225 -> north
        225 - 315 -> east
        315 - 360  -> south
        */
        if ((dirnDeg >= 0 && dirnDeg < 45) || (dirnDeg >= 315 && dirnDeg <= 360)) {
            return "S"
        } else if (dirnDeg >= 45 && dirnDeg < 135) {
            return "W"
        } else if (dirnDeg >= 135 && dirnDeg < 225) {
            return "N"
        } else if (dirnDeg >= 225 && dirnDeg < 315) {
            return "E"
        }
        return ""
    }
}


// WEBPACK FOOTER //
// ./src/models/weatherData.js